import React, { Component } from "react";
import { history } from "../../helpers/history";
import SaayaLogo from "../../static/images/saayalogo.svg";

class NotFound extends Component {
  redirectToHome() {
    history.push("/home");
  }

  render() {
    return (
      <div>
        <div className="container text-center w-100">
          <div className="notfound-logo">
          {
            <img className="logo" src={SaayaLogo} alt="SaayaHealth logo" /> 
          }            
          <div className="p-4">
              <h1 className="display-1">404</h1>
              <h2 className="h3">Page Not Found</h2>
            </div>
            <button
               className="btn  btn-primary  pl-5 pr-5 mb-0 custom-btn"
              onClick={this.redirectToHome}
            >
              Go To Home Page
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/Not Found/index.js